import React, { useContext, useEffect, useState } from "react";
import EditUserForm from "../../components/users/EditUserForm";
import Pagination from "../../components/global/Pagination";
import PanelTitle from "../../components/global/PanelTitle";
import HeaderRow from "../../components/global/HeaderRow";
import { ModalContext } from "../../context/ModalContext";
import { UsersContext } from "../../context/UsersContext";
import UserForm from "../../components/users/UserForm";
import UserRow from "../../components/users/UserRow";

const AdminUsuarios = () => {
  const [page, setPage] = useState(1);
  const [query, setQuery] = useState("");

  const { users, getUsers, deleteUser, clearUsers } = useContext(UsersContext);

  const { modalComponent } = useContext(ModalContext);

  useEffect(() => {
    getUsers({ page, query });
    return clearUsers;
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, query]);

  const handleCreate = () => {
    modalComponent("Agregar Usuario", <UserForm />);
  };

  const handleEdit = (user) => {
    modalComponent("Editar Usuario", <EditUserForm user={user} />);
  };

  const confirmDelete = (user) => {
    modalComponent(
      "Eliminar Usuario",
      <div>
        <p>
          ¿Estás seguro que deseas eliminar al usuario {user.customer.email}?
        </p>
        <button
          className="btn btn-danger"
          onClick={() => deleteUser(user.user_id)}
        >
          Eliminar
        </button>
      </div>
    );
  };

  const renderUsers = () => {
    if (Array.isArray(users)) {
      if(users.length === 0) {
        return <p className="mt-3 mb-0">No hay usuarios registrados</p>;
      }
      return users.map((user) => (
        <UserRow
          key={user.user_id}
          user={user}
          editUser={handleEdit}
          deleteUser={confirmDelete}
        />
      ));
    }
  };

  const gerHeaderCols = () => {
    const cols = [];
    cols.push("Nombre");
    cols.push("Correo Electrónico", "Rol", "Acciones");
    return cols;
  };

  return (
    <div className="container-fluid">
      <PanelTitle title="Usuarios" onClick={handleCreate} />
      <div className="card p-2 no-scale shadow">
        <input
          type="text"
          className="form-control mt-1"
          placeholder="Buscar por nombre o correo electrónico..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
        />
        <HeaderRow headers={gerHeaderCols()} />
        <div className="container-fluid">{renderUsers()}</div>
        <Pagination setPage={setPage} page={page} />
      </div>
    </div>
  );
};

export default AdminUsuarios;
